import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import {
  FiChevronLeft,
  FiChevronRight,
  FiCheckCircle,
  FiMapPin
} from "react-icons/fi";
import {
  FaStar,
  FaQuoteRight,
  FaUsers,
  FaAward,
  FaBuilding,
  FaThumbsUp,
  FaHome
} from "react-icons/fa";
import "swiper/css";
import "./TestimonialsNew.css";

const testimonialsData = [
  {
    id: 1,
    name: "Aashvi Agarwal",
    role: "Tenant & Relocator",
    property: "Rented Gated Apartment in Gachibowli",
    location: "Hyderabad",
    avatar: "/assets/images/avatar/2.jpg",
    rating: 5,
    quote:
      "Relocating to Hyderabad for work was daunting until I contacted EwRealty. Found a fully furnished home within 48 hours without any hidden brokerage surprises.",
    tag: "Verified Tenant",
    tagType: "verified",
  },
  {
    id: 2,
    name: "Vikramaditya Varma",
    role: "Luxury Villa Owner",
    property: "Bought Independent Villa in Kokapet",
    location: "Hyderabad",
    avatar: "/assets/images/avatar/3.jpg",
    rating: 5,
    quote:
      "The premium portfolio and discreet handling of luxury properties was top tier. The team understood our high expectations and delivered beyond what we imagined.",
    tag: "Villa Owner",
    tagType: "villa",
  },
  {
    id: 3,
    name: "Aryan & Ritu Khan",
    role: "Commercial Investor",
    property: "Office Space in Financial District",
    location: "Hyderabad",
    avatar: "/assets/images/avatar/4.jpg",
    rating: 5,
    quote:
      "High rental yield and verified builder track record were our main concerns. Their commercial market insights and end-to-end documentation were impeccable.",
    tag: "Commercial Investor",
    tagType: "commercial",
  },
  {
    id: 4,
    name: "Karan Rajput",
    role: "Property Buyer",
    property: "Purchased 3 BHK in Hitec City",
    location: "Hyderabad",
    avatar: "/assets/images/avatar/1.jpeg",
    rating: 5,
    quote:
      "EwRealty made our dream home purchase seamless. From property shortlisting to legal verification and registry, their transparent guidance saved us so much time and stress.",
    tag: "Verified Buyer",
    tagType: "verified",
  },
  {
    id: 5,
    name: "Priya Sharma",
    role: "First-time Buyer",
    property: "Purchased 2 BHK in Kondapur",
    location: "Hyderabad",
    avatar: "/assets/images/avatar/5.jpg",
    rating: 5,
    quote:
      "As a first-time homebuyer, I had hundreds of questions regarding home loans and builder approvals. Their dedicated advisor walked me through every step patiently.",
    tag: "Verified Buyer",
    tagType: "verified",
  },
  {
    id: 6,
    name: "Rohan Mehta",
    role: "Property Seller",
    property: "Sold Penthouse in Jubilee Hills",
    location: "Hyderabad",
    avatar: "/assets/images/avatar/6.jpg",
    rating: 5,
    quote:
      "Listed my property on EwRealty and received genuine qualified buyer leads within a week. Closed the deal at my expected market price smoothly.",
    tag: "Villa Owner",
    tagType: "villa",
  },
];

const statsData = [
  {
    id: 1,
    number: "15,000+",
    label: "Happy Homeowners & Tenants",
    icon: <FaUsers />,
  },
  {
    id: 2,
    number: "98.5%",
    label: "Customer Satisfaction Rate",
    icon: <FaThumbsUp />,
  },
  {
    id: 3,
    number: "4,500+",
    label: "Verified Property Listings",
    icon: <FaBuilding />,
  },
  {
    id: 4,
    number: "12+ Years",
    label: "Real Estate Trust & Excellence",
    icon: <FaAward />,
  },
];

const OurClientSays = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [activeDot, setActiveDot] = useState(0);

  const handleSlideChange = (swiper) => {
    const currentReal = swiper.realIndex || 0;
    setActiveDot(currentReal % Math.ceil(testimonialsData.length / 2));
  };

  const handleDotClick = (index) => {
    if (swiperInstance) {
      swiperInstance.slideToLoop(index * 2);
      setActiveDot(index);
    }
  };

  const renderBadge = (tag, tagType) => {
    if (tagType === "verified") {
      return (
        <span className="mgh-testim-tag-badge mgh-testim-badge-verified">
          <FiCheckCircle className="mgh-testim-badge-icon" />
          <span>{tag}</span>
        </span>
      );
    }
    if (tagType === "commercial") {
      return (
        <span className="mgh-testim-tag-badge mgh-testim-badge-peach">
          <FaBuilding className="mgh-testim-badge-icon" />
          <span>{tag}</span>
        </span>
      );
    }
    return (
      <span className="mgh-testim-tag-badge mgh-testim-badge-peach">
        <FaHome className="mgh-testim-badge-icon" />
        <span>{tag}</span>
      </span>
    );
  };

  return (
    <section
      className="mgh-testimonials-section"
      id="testimonials"
      style={{ backgroundImage: "url('/assets/images/testimonials_bg.jpg')" }}
      aria-label="Customer Reviews and Testimonials"
    >
      <div className="mgh-testimonials-container">
        {/* Centered Section Header */}
        <div className="mgh-testim-header-center">
          <div className="mgh-testim-sub-kicker">
            <span className="mgh-testim-kicker-line"></span>
            <span>TESTIMONIALS & REVIEWS</span>
            <span className="mgh-testim-kicker-line"></span>
          </div>
          <h2 className="mgh-testim-title">
            What Our <span className="mgh-testim-title-orange">Clients Say</span>
          </h2>

        </div>

        {/* Testimonials Swiper Carousel */}
        <div className="mgh-testim-swiper-wrap">
          <Swiper
            onSwiper={setSwiperInstance}
            onSlideChange={handleSlideChange}
            slidesPerView={3}
            spaceBetween={24}
            loop={true}
            speed={650}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 16,
              },
              700: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1080: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
            modules={[Autoplay]}
            className="mgh-testim-swiper"
          >
            {testimonialsData.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="mgh-testim-card-frame">
                  {/* Luxury Corner Swoosh Accents */}
                  <div className="mgh-testim-corner-tl" aria-hidden="true"></div>
                  <div className="mgh-testim-corner-br" aria-hidden="true"></div>

                  <div className="mgh-testim-card">
                    {/* Top Row: Badge + Rating Stars */}
                    <div className="mgh-testim-card-topbar">
                      {renderBadge(item.tag, item.tagType)}
                      <div className="mgh-testim-stars-row" aria-label={`Rating ${item.rating} out of 5 stars`}>
                        {[...Array(item.rating)].map((_, idx) => (
                          <FaStar key={idx} className="mgh-testim-star-icon" />
                        ))}
                      </div>
                    </div>

                    {/* Location / Property Pill */}
                    <div className="mgh-testim-location-pill">
                      <FiMapPin className="mgh-testim-location-icon" />
                      <span>{item.property}</span>
                    </div>

                    {/* Quote Row with Opening Quote Mark */}
                    <div className="mgh-testim-quote-row">
                      <span className="mgh-testim-quote-mark-open" aria-hidden="true">“</span>
                      <p className="mgh-testim-quote-text">{item.quote}</p>
                    </div>

                    {/* Author Footer with Avatar, Info, and Closing Quote Mark */}
                    <div className="mgh-testim-card-footer">
                      <div className="mgh-testim-author-meta">
                        <div className="mgh-testim-avatar-wrap">
                          <img
                            src={item.avatar}
                            alt={item.name}
                            className="mgh-testim-avatar-img"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/assets/images/avatar/1.jpeg";
                            }}
                          />
                        </div>
                        <div className="mgh-testim-author-info">
                          <h4 className="mgh-testim-author-name">{item.name}</h4>
                          <span className="mgh-testim-author-role">
                            {item.role} • {item.location}
                          </span>
                        </div>
                      </div>
                      <span className="mgh-testim-quote-mark-close" aria-hidden="true">”</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Dots Pagination */}
          <div className="mgh-testim-dots-container">
            {[0, 1, 2].map((idx) => (
              <button
                key={idx}
                type="button"
                className={`mgh-testim-dot ${activeDot === idx ? "active" : ""}`}
                onClick={() => handleDotClick(idx)}
                aria-label={`Go to slide page ${idx + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Achievement / Stats Banner */}
        <div className="mgh-stats-banner">
          <div className="mgh-stats-grid">
            {statsData.map((stat) => (
              <div key={stat.id} className="mgh-stats-item">
                <div className="mgh-stats-icon-circle">{stat.icon}</div>
                <div className="mgh-stats-text">
                  <span className="mgh-stats-number">{stat.number}</span>
                  <span className="mgh-stats-label">{stat.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurClientSays;
